// src/pages/user/UserDetailPage.js

import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import UserService from '../../services/usageServices';
const UserDetailPage = () => {
  const { isLogged } = useContext(AuthContext);
  const { userId } = useParams();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!isLogged) return;

    UserService.getUserById(userId)
      .then((res) => {
        setUser(res.data);
      })
      .catch((err) => console.error('Erreur lors de la récupération de l\'utilisateur :', err));
  }, [isLogged, userId]);

  return (
    <div>
      <h2>Détails de l'utilisateur</h2>
      {user ? (
        <div>
          <p>Nom: {user.name}</p>
          <p>Email: {user.email}</p>
          <p>Rôle: {user.role}</p>
        </div>
      ) : (
        <p>Utilisateur non trouvé.</p>
      )}
    </div>
  );
};

export default UserDetailPage;
